import { Component, ChangeDetectionStrategy } from '@angular/core';
import {Dialog} from "@angular/cdk/dialog";
import {InfoComponent} from "../../dialogs/info/info.component";
import {RouterModule} from "@angular/router";
import {NgOptimizedImage} from "@angular/common";

@Component({
    selector: 'app-index',
  imports: [RouterModule, NgOptimizedImage, NgOptimizedImage],
    templateUrl: './index.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './index.page.scss'
})
export class IndexPage {
  constructor(private dialog: Dialog) {
  }

  openInfo(_e: MouseEvent) {
    this.dialog.open(InfoComponent)
  }
}
